module.exports = __webpack_public_path__ + "img/600.b1fb6795.svg";